export function formatTime(seconds = 0) {
  if (!Number.isFinite(seconds) || seconds < 0) return '0:00'
  const total = Math.floor(seconds)
  const hours = Math.floor(total / 3600)
  const mins = Math.floor((total % 3600) / 60)
  const secs = total % 60
  return hours > 0
    ? `${hours}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
    : `${mins}:${String(secs).padStart(2, '0')}`
}

/** Binary units throughout, matching formatFileSize: the two appear side by
 * side in the diagnostics readout and used to disagree by about 7%. */
export function formatBytesPerSecond(bytes = 0) {
  if (!bytes || bytes < 0) return '0 MB/s'
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB/s`
  return `${Math.round(bytes / 1024)} KB/s`
}

export function formatFileSize(bytes = 0) {
  if (!bytes || bytes < 0) return 'Size unknown'
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  let value = bytes
  let unit = 0
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024
    unit += 1
  }
  const digits = value >= 10 || unit === 0 ? 0 : 1
  return `${value.toFixed(digits)} ${units[unit]}`
}

export function compactStreamTitle(title = '') {
  return title
    .split('\n')
    // Alternation, not a character class: ⚙️ is a base character plus a
    // variation selector, and a class would match that selector on its own.
    .filter((line) => !/👤|💾|⚙️/u.test(line))
    .join(' · ')
    .trim()
}

/** "22 min left" — what a viewer wants from a part-watched item. */
export function formatRemaining(currentTime = 0, duration = 0) {
  const left = Math.max(0, duration - currentTime)
  if (!duration || left < 60) return 'Almost finished'
  const minutes = Math.round(left / 60)
  if (minutes < 60) return `${minutes} min left`
  const hours = Math.floor(minutes / 60)
  const rest = minutes % 60
  return rest ? `${hours} h ${rest} min left` : `${hours} h left`
}

/** MetaHub serves size variants. A TV card never needs a full original poster,
 * so cap it at the small asset before the browser allocates a decoded bitmap. */
export function posterUrl(url = '') {
  return url.replace(/\/poster\/(?:medium|large|original)\//i, '/poster/small/')
}
